import { createAction, createAsyncAction } from 'typesafe-actions'
import {
  CreateBusinessEntityRequestDto,
  CreateBusinessEntityResponseDto,
  GetBusinessEntityDetailsResponseDto,
  ReadBusinessEntitiesRequestDto,
  ReadBusinessEntitiesResponseDto,
  GetUsersForAssignEntityResponseDto,
  UpdateBusinessEntityDetailsRequestDto,
  UpdateBusinessEntityUsersRequestDto,
  UpdateBusinessEntitySettingsRequestDto,
  GetBusinessEntityDetailsRequestDto,
  DeleteBusinessEntityUserRequestDto,
  ReadBusinessEntitiesForAssignToUserResponseDto,
  ReadBusinessEntitiesForAssignUserRequestDto,
  GetUsersForAssignEntityRequestDto,
} from '@sparling/financial-common'

export const {
  request: getBusinessEntitiesRequest,
  success: getBusinessEntitiesSuccess,
  failure: getBusinessEntitiesFailure,
} = createAsyncAction(
  'GET_BUSINESS_ENTITIES_REQUEST',
  'GET_BUSINESS_ENTITIES_SUCCESS',
  'GET_BUSINESS_ENTITIES_FAILURE',
)<ReadBusinessEntitiesRequestDto, ReadBusinessEntitiesResponseDto, Error>()

export const {
  request: getBusinessEntitiesForAssignToUserRequest,
  success: getBusinessEntitiesForAssignToUserSuccess,
  failure: getBusinessEntitiesForAssignToUserFailure,
} = createAsyncAction(
  'GET_BUSINESS_ENTITIES_FOR_ASSIGN_TO_USER_REQUEST',
  'GET_BUSINESS_ENTITIES_FOR_ASSIGN_TO_USER_SUCCESS',
  'GET_BUSINESS_ENTITIES_FOR_ASSIGN_TO_USER_FAILURE',
)<ReadBusinessEntitiesForAssignUserRequestDto, ReadBusinessEntitiesForAssignToUserResponseDto, Error>()

export const {
  request: getBusinessEntityDetailsRequest,
  success: getBusinessEntityDetailsSuccess,
  failure: getBusinessEntityDetailsFailure,
} = createAsyncAction(
  'GET_BUSINESS_ENTITY_DETAILS_REQUEST',
  'GET_BUSINESS_ENTITY_DETAILS_SUCCESS',
  'GET_BUSINESS_ENTITY_DETAILS_FAILURE',
)<{ id: string } & GetBusinessEntityDetailsRequestDto, GetBusinessEntityDetailsResponseDto, Error>()

export const {
  request: getUsersForAssignEntityRequest,
  success: getUsersForAssignEntitySuccess,
  failure: getUsersForAssignEntityFailure,
} = createAsyncAction(
  'GET_USERS_FOR_ASSIGN_TO_ENTITY_REQUEST',
  'GET_USERS_FOR_ASSIGN_TO_ENTITY_SUCCESS',
  'GET_USERS_FOR_ASSIGN_TO_ENTITY_FAILURE',
)<GetUsersForAssignEntityRequestDto, GetUsersForAssignEntityResponseDto, Error>()

export const {
  request: createBusinessEntitiesRequest,
  success: createBusinessEntitiesSuccess,
  failure: createBusinessEntitiesFailure,
} = createAsyncAction(
  'CREATE_BUSINESS_ENTITIES_REQUEST',
  'CREATE_BUSINESS_ENTITIES_SUCCESS',
  'CREATE_BUSINESS_ENTITIES_FAILURE',
)<CreateBusinessEntityRequestDto, CreateBusinessEntityResponseDto, Error>()

export const {
  request: updateBusinessEntityDetailsRequest,
  success: updateBusinessEntityDetailsSuccess,
  failure: updateBusinessEntityDetailsFailure,
} = createAsyncAction(
  'UPDATE_BUSINESS_ENTITY_DETAILS_REQUEST',
  'UPDATE_BUSINESS_ENTITY_DETAILS_SUCCESS',
  'UPDATE_BUSINESS_ENTITY_DETAILS_FAILURE',
)<{ id: string } & UpdateBusinessEntityDetailsRequestDto, GetBusinessEntityDetailsResponseDto, Error>()

export const {
  request: updateBusinessEntityUsersRequest,
  success: updateBusinessEntityUsersSuccess,
  failure: updateBusinessEntityUsersFailure,
} = createAsyncAction(
  'UPDATE_BUSINESS_ENTITY_USERS_REQUEST',
  'UPDATE_BUSINESS_ENTITY_USERS_SUCCESS',
  'UPDATE_BUSINESS_ENTITY_USERS_FAILURE',
)<{ id: string } & UpdateBusinessEntityUsersRequestDto, GetBusinessEntityDetailsResponseDto, Error>()

export const {
  request: deleteBusinessEntityUsersRequest,
  success: deleteBusinessEntityUsersSuccess,
  failure: deleteBusinessEntityUsersFailure,
} = createAsyncAction(
  'DELETE_BUSINESS_ENTITY_USERS_REQUEST',
  'DELETE_BUSINESS_ENTITY_USERS_SUCCESS',
  'DELETE_BUSINESS_ENTITY_USERS_FAILURE',
)<{ id: string } & DeleteBusinessEntityUserRequestDto, GetBusinessEntityDetailsResponseDto, Error>()

export const {
  request: updateBusinessEntitySettingsRequest,
  success: updateBusinessEntitySettingsSuccess,
  failure: updateBusinessEntitySettingsFailure,
} = createAsyncAction(
  'UPDATE_BUSINESS_ENTITY_SETTINGS_REQUEST',
  'UPDATE_BUSINESS_ENTITY_SETTINGS_SUCCESS',
  'UPDATE_BUSINESS_ENTITY_SETTINGS_FAILURE',
)<{ id: string } & UpdateBusinessEntitySettingsRequestDto, GetBusinessEntityDetailsResponseDto, Error>()

export const resetBusinessEntitiesFilters = createAction('RESET_BUSINESS_ENTITIES_FILTERS')<undefined>()
export const resetCreatedBusinessEntity = createAction('RESET_CREATED_BUSINESS_ENTITY')<undefined>()
